import React from 'react';
import { Upload, Trash2 } from 'lucide-react';

interface BusinessDoc {
  file_url: string;
  title: string;
  notes: string;
}

interface Step8Props {
  documents: BusinessDoc[];
  onAdd: () => void;
  onUpdate: (index: number, field: string, value: string) => void;
  onRemove: (index: number) => void;
}

export default function Step8BusinessDocs({ documents, onAdd, onUpdate, onRemove }: Step8Props) {
  return (
    <div className="space-y-4">
      {documents.map((doc, index) => (
        <div key={index} className="border rounded-lg p-4 space-y-3">
          <div className="flex justify-between items-start">
            <h4 className="font-medium">Dokumen #{index + 1}</h4>
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="p-1 text-red-500 hover:bg-red-50 rounded"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>

          <div className="space-y-3">
            <input
              type="file"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />

            <input
              type="text"
              placeholder="Judul Dokumen"
              value={doc.title}
              onChange={e => onUpdate(index, 'title', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />

            <textarea
              placeholder="Catatan"
              value={doc.notes}
              onChange={e => onUpdate(index, 'notes', e.target.value)}
              rows={2}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 transition-colors duration-200"
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={onAdd}
        className="w-full flex items-center justify-center gap-2 px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors"
      >
        <Upload className="w-4 h-4" /> Upload Dokumen
      </button>
    </div>
  );
}
